import { useNavigate } from 'react-router-dom';
import { FileText, Zap, Shield, Download } from 'lucide-react';

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-ledger-bone relative noise-overlay">
      <div className="relative z-10">
        {/* Header */}
        <header className="border-b border-black/10 bg-ledger-bone">
          <div className="max-w-7xl mx-auto px-6 py-6 flex justify-between items-center">
            <h1 className="font-serif text-2xl font-bold tracking-tight text-ledger-green" data-testid="logo">StatementCSV</h1>
            <button
              onClick={() => navigate('/auth')}
              className="bg-ledger-green text-white rounded-none hover:bg-ledger-green/90 uppercase tracking-widest text-xs py-3 px-6 font-mono"
              data-testid="header-get-started-btn"
            >
              Get Started
            </button>
          </div>
        </header>

        {/* Hero */}
        <section className="max-w-7xl mx-auto px-6 py-24">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-7 space-y-8">
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-ledger-green leading-tight">
                Bank Statements to Clean CSV.
                <br />
                <span className="text-ledger-orange">In Seconds.</span>
              </h1>
              <p className="text-base font-mono text-gray-600 max-w-xl mb-4">
                Upload PDF or image bank statements. Our AI extracts transactions and delivers ready-to-use CSV files. No manual data entry.
              </p>
              <div className="bg-ledger-orange/10 border-2 border-ledger-orange px-4 py-2 inline-block">
                <p className="font-mono text-sm font-bold text-ledger-orange">🎁 Try it FREE - 1 extraction included</p>
              </div>
              <div className="flex gap-4">
                <button
                  onClick={() => navigate('/auth')}
                  className="bg-ledger-orange text-white rounded-none hover:bg-ledger-orange/90 uppercase tracking-widest text-xs py-4 px-8 font-mono"
                  data-testid="hero-get-started-btn"
                >
                  Start Converting
                </button>
              </div>
            </div>
            <div className="md:col-span-5 flex items-center justify-center">
              <div className="w-full h-64 bg-black/5 border-2 border-ledger-green flex items-center justify-center">
                <FileText className="w-24 h-24 text-ledger-green" />
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="max-w-7xl mx-auto px-6 py-24 border-t border-black/10">
          <h2 className="font-serif text-3xl font-bold text-ledger-green mb-12">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="border-2 border-black/10 p-8 bg-white">
              <Zap className="w-8 h-8 text-ledger-orange mb-4" />
              <h3 className="font-mono text-sm uppercase tracking-widest mb-2">Upload</h3>
              <p className="font-mono text-xs text-gray-600">Drop your PDF or image bank statement</p>
            </div>
            <div className="border-2 border-black/10 p-8 bg-white">
              <Shield className="w-8 h-8 text-ledger-orange mb-4" />
              <h3 className="font-mono text-sm uppercase tracking-widest mb-2">AI Parsing</h3>
              <p className="font-mono text-xs text-gray-600">Gemini 2.0 Flash extracts all transactions</p>
            </div>
            <div className="border-2 border-black/10 p-8 bg-white">
              <FileText className="w-8 h-8 text-ledger-orange mb-4" />
              <h3 className="font-mono text-sm uppercase tracking-widest mb-2">Review</h3>
              <p className="font-mono text-xs text-gray-600">View extracted data in clean table format</p>
            </div>
            <div className="border-2 border-black/10 p-8 bg-white">
              <Download className="w-8 h-8 text-ledger-orange mb-4" />
              <h3 className="font-mono text-sm uppercase tracking-widest mb-2">Download</h3>
              <p className="font-mono text-xs text-gray-600">Get your CSV file instantly</p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-7xl mx-auto px-6 py-24 border-t border-black/10">
          <div className="border-2 border-ledger-green p-12 bg-white text-center">
            <h2 className="font-serif text-3xl font-bold text-ledger-green mb-4">Ready to streamline your workflow?</h2>
            <p className="font-mono text-sm text-gray-600 mb-6">Join finance professionals who trust StatementCSV</p>
            <button
              onClick={() => navigate('/auth')}
              className="bg-ledger-orange text-white rounded-none hover:bg-ledger-orange/90 uppercase tracking-widest text-xs py-4 px-8 font-mono"
              data-testid="cta-get-started-btn"
            >
              Get Started Free
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="border-t border-black/10 py-8">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <p className="font-mono text-xs text-gray-500">© 2025 StatementCSV. Powered by Google Gemini AI.</p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Landing;